module.exports = __webpack_public_path__ + "img/bidbuy_null.f7596c4f.png";